var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "case-time-button-wrapper" }, [
    _c(
      "button",
      {
        staticClass: "pt-ui-btn",
        attrs: { "data-type": "plain", border: "" },
        on: { click: _vm.onClick },
      },
      [_vm._v(" " + _vm._s(_vm.$t("case_time.case_timer_btn")) + " ")]
    ),
    _vm.IsRecording
      ? _c("div", { staticClass: "case-time-button__tip-recording" })
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }